export enum DataTypes {
    STRING = "string",
    NUMBER = "number",
    BOOLEAN = "boolean",
    DATE = "date",
    FILE = "file",
    OBJECT = "object",
    UNDEFINED = "undefined",
}
